/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'CportalModule';
const componentName = 'smart-operations-widget';
const prefix = `${moduleName}.${componentName}`;

export const smartOperationsHeader = `${prefix}.smartOperationsHeader`;
export const pulseCloudServiceOrgDashboardsLabel = `${prefix}.pulseCloudServiceOrgDashboardsLabel`;
export const enabledLabel = `${prefix}.enabledLabel`;
export const deactivatedLabel = `${prefix}.deactivatedLabel`;

export const ENGLISH = {
    [smartOperationsHeader]: 'Smart Operations',
    [pulseCloudServiceOrgDashboardsLabel]: 'Pulse Cloud Service Org Dashboards for Central visibility',
    [enabledLabel]: 'Enabled',
    [deactivatedLabel]: 'Deactivated',
};
